module.exports = __webpack_public_path__ + "4fe30872493128fd73a4120086a53d9f.svg";